module.exports = __webpack_public_path__ + "img/logo.76540f9a.png";